/**
 * Display label for a broker / underwriter / user.
 *
 * Prefer a real name when present; fall back to email (ghosts and unnamed
 * accounts). Truncation for table cells should use CSS ``truncate``.
 */
export function getUserDisplayName(
  name?: string | null,
  email?: string | null,
  fallback = "Unknown"
): string {
  const trimmedName = (name || "").trim();
  if (trimmedName) return trimmedName;
  const trimmedEmail = (email || "").trim();
  if (trimmedEmail) return trimmedEmail;
  return fallback;
}

/**
 * @deprecated Prefer ``getUserDisplayName(name, email)``. Kept for call sites
 * that still only have an email string (truncates long emails at ``@``).
 */
export function getBrokerDisplayName(
  email: string | undefined | null,
  fallback?: string,
  maxLength = 32
): string {
  if (email) {
    return email.length > maxLength ? email.split("@")[0] : email;
  }
  return fallback || "Unknown";
}
